'use client';

import { IconButton, Tooltip } from '@terra/ui-design-system';
import { Delete02Icon, Message01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { ArchivedActionGate } from './ArchivedActionGate';

export function AssetDetailsHeaderMutations({
  isArchived,
  onDelete,
  onSendToCopilot,
}: {
  isArchived: boolean;
  onDelete: () => void;
  onSendToCopilot?: () => void;
}) {
  const tLifecycle = useTranslations('designSystem.lifecycle');
  const tCommon = useTranslations('designSystem.common');
  const tSignalsBulk = useTranslations('signals.bulkActions');
  const archivedActionTooltip = tLifecycle('archivedAssetActionTooltip');
  const deleteLabel = tCommon('delete');
  const sendToCopilotLabel = tSignalsBulk('sendToCopilot');

  return (
    <>
      {onSendToCopilot ? (
        <ArchivedActionGate
          isArchived={isArchived}
          tooltip={archivedActionTooltip}
        >
          <Tooltip title={sendToCopilotLabel}>
            <IconButton
              size="xs"
              variant="ghost"
              colorScheme="red"
              aria-label={sendToCopilotLabel}
              onClick={onSendToCopilot}
            >
              <Message01Icon size={14} />
            </IconButton>
          </Tooltip>
        </ArchivedActionGate>
      ) : null}
      <ArchivedActionGate
        isArchived={isArchived}
        tooltip={archivedActionTooltip}
      >
        <Tooltip title={deleteLabel}>
          <IconButton
            variant="ghost"
            size="xs"
            aria-label={deleteLabel}
            onClick={onDelete}
          >
            <Delete02Icon size={14} />
          </IconButton>
        </Tooltip>
      </ArchivedActionGate>
    </>
  );
}
